/** Compact sm-button styling for recognition draft focus/tone tabs — mirrors bizy-desktop. */
export const RECOGNITION_DRAFT_FOCUS_TAB_PROPS = {
	fontFamily: 'ui',
	fontSize: 'sm',
	fontWeight: 'medium',
	lineHeight: '5',
	px: '12px',
	py: '6px',
} as const;
